/*
 * Stratus chrome: cart counts and amounts. Loaded with defer by snippets/st-header-assets.liquid.
 * Keeps [data-st-cart-count] (header bag, hidden at 0), [data-st-cart-count-parens] (drawer title "(n)", hidden at 0)
 * and [data-st-cart-total-money] (cart page checkout amount) current by re-reading /cart.js, debounced, on
 * theme:cart:added, theme:cart:refresh and theme:cart:loaded, and whenever theme.js rewrites [data-cart-total-price].
 */
(() => {
  let timer;
  const watched = new WeakSet();

  const money = (cents) =>
    window.theme && theme.formatMoney ? theme.formatMoney(cents, theme.moneyFormat) : (cents / 100).toFixed(2);

  const apply = (cart) => {
    const n = cart.item_count;
    document.querySelectorAll('[data-st-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-st-cart-count-parens]').forEach((el) => {
      el.textContent = `(${n})`;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-st-cart-total-money]').forEach((el) => {
      el.innerHTML = money(cart.total_price);
    });
  };

  const url = () => {
    const routes = (window.theme && theme.routes) || {};
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return `${routes.cart_url || `${root}cart`}.js`;
  };

  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fetch(url(), { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => cart && apply(cart))
        .catch(() => {});
    }, 150);
  };

  const observer = new MutationObserver(refresh);
  const watch = () => {
    document.querySelectorAll('[data-cart-total-price]').forEach((el) => {
      if (watched.has(el)) return;
      watched.add(el);
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  };

  ['theme:cart:added', 'theme:cart:refresh', 'theme:cart:loaded'].forEach((type) =>
    document.addEventListener(type, () => {
      watch();
      refresh();
    })
  );
  watch();
})();
